import React, { useState, useEffect } from 'react';
import { getAllRegistrations } from '../../API/atelierRegistrationAPI';

const AtelierDataSection = () => {
    const [registrations, setRegistrations] = useState([]);

    useEffect(() => {
        const fetchRegistrations = async () => {
            try {
                const data = await getAllRegistrations();
                console.log(data.registrations)
                setRegistrations(data.registrations);  
            } catch (error) {
                console.error('Error fetching inquiries:', error);
            }
        };
        
        fetchRegistrations();
    }, []); 

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    };

    const formatTime = (timeString) => {
        const [hours, minutes, seconds] = timeString.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(seconds);
    
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true, 
        });
    };

    return (
        <div className="flex h-screen">
            <div className="flex-1 p-6">
                <div className="flex justify-between items-center border-b pb-4">
                    <h2 className="text-3xl font-bold">Atelier Registrations</h2>
                </div>

                <div className="mt-6 overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">Name</th>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">Email</th>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">Mobile Number</th>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">No of Participants</th>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">Date</th>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {registrations.map((registration, index) => (
                                <tr key={index} className="border-t">
                                    <td className="px-6 py-3 text-sm text-gray-700">{registration.name}</td>
                                    <td className="px-6 py-3 text-sm text-gray-700">{registration.email}</td>
                                    <td className="px-6 py-3 text-sm text-gray-700">{registration.mobile}</td>
                                    <td className="px-6 py-3 text-sm text-gray-700">{registration.participants}</td>
                                    <td className="px-6 py-3 text-sm text-gray-700">{formatDate(registration.date)}</td>
                                    <td className="px-6 py-3 text-sm text-gray-700">{formatTime(registration.time)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AtelierDataSection;
